import { useEffect, useState } from "react";
import { fetchMinStayScope, type MinStayScopeStatus } from "../services/pricingApi";
import { fetchAutoSyncMinStayScope } from "../services/autoSyncApi";

/**
 * How the PMS keeps minimum stays — one per night for every room type (a
 * Previo hotel kept per season), or one per room type — asked while `enabled`:
 * a dialog is open with minimum stays switched on. The active property's
 * unless `connectionId` names one, as the auto-sync dialog does for the
 * property its card names.
 *
 * The question names the property and nothing of the send: it used to carry
 * the send as it stood on screen, for a count of what the send would change
 * in the PMS that the dialogs drew until 21 Oct 2026.
 *
 * Null until the answer arrives, and whenever the question fails: this only
 * decides what a dialog says, and the send reads the PMS again for itself.
 */
export function useMinStayScope(enabled: boolean, connectionId?: number): MinStayScopeStatus | null {
    const [status, setStatus] = useState<MinStayScopeStatus | null>(null);

    useEffect(() => {
        if (!enabled) {
            // A dialog opened again must not show the last answer before the
            // new one: the hotel may have changed the setting in the PMS since.
            setStatus(null);
            return;
        }
        let cancelled = false;
        const asking = connectionId === undefined ? fetchMinStayScope() : fetchAutoSyncMinStayScope(connectionId);
        asking.then(
            (answer) => {
                if (!cancelled) setStatus(answer);
            },
            () => {
                // Left to the send's own reading.
            },
        );
        return () => {
            cancelled = true;
        };
    }, [enabled, connectionId]);

    return enabled ? status : null;
}
